import React from 'react';
import SwiggyCardsLayout from './layouts/SwiggyCardsLayout';
import ZomatoCompactLayout from './layouts/ZomatoCompactLayout';
import GridLayout from './layouts/GridLayout';
import ListLayout from './layouts/ListLayout';
import PDFLayout from './layouts/PDFLayout';

export default function LayoutEngine(props) {
    const { config } = props;
    
    // Default to swiggy if config is malformed somehow
    const layoutType = config?.customization?.menu_layout?.type || 'swiggy_cards';

    switch (layoutType) {
        case 'swiggy_cards':
            return <SwiggyCardsLayout {...props} />;
        case 'zomato_compact':
            return <ZomatoCompactLayout {...props} />;
        case 'grid':
            return <GridLayout {...props} />;
        case 'list':
            return <ListLayout {...props} />;
        case 'pdf_style':
            return <PDFLayout {...props} />;
        default:
            return <SwiggyCardsLayout {...props} />;
    }
}
